import { mutatorAction } from "satcheljs";
import { TimeOffReasonsStore } from "..";

export default mutatorAction(
    "SET_REQUESTABLE_TIME_OFF_REASONS_IN_STORE",
    function setRequestableTimeOffReasonsInStore(timeOffReasonsIds: string[]) {
        TimeOffReasonsStore().requestableTimeOffReasonsIds = timeOffReasonsIds;
    }
);
